// extracted by mini-css-extract-plugin
module.exports = {"root":"aWuDyXRI","midTypes":"k6IDvF1q"};